var exports = {
  "k": "xe564cbfb--205a93--container",
};

module.exports = exports;
